// import happyPackage from '@/../config/happyPackage.json';
import happyPackageApi from '@/api/happyPackage/happyPackageApi.js';
import breadCrumb from '@/store/breadCrumb';
import store from '@/store/store';

export default {
	name: 'happy-package',
	mixins: [],
	extends: {},
	components: {},
	props: [ 'selectedKey' ],
	data() {
		return {
			happyPackages: null,
			happyPackageGroups: null,
			happyPackageMapping2Group: {
				'happyPackagekey': 'happyPackageGroupKey'
			},
			selectedApplyStatus:'',
			sameAsOriginalErr: false, // default
			selectedHappyPackage: {},
			selectedHappyPackageGroup: {},
			getSetServiceStatusResp: {
				applyStatus:'',
				canCancel:'',
			},
		};
	},
	computed: {
		id() {
			return this.selectedHappyPackage.id;
		},
		key() {
			return this.selectedHappyPackage.key;
		},
		title() {
			return this.selectedHappyPackage.title;
		},
		description() {
			return this.selectedHappyPackage.description;
		},
		billingMethod() {
			return this.selectedHappyPackage.billingMethod;
		},
		notices() {
			return this.selectedHappyPackage.notices;
		}
	},
	watch: {
		async selectedKey() {
			await this.checkSelectedKey();
			await this.checkQuickLogin();
			this.initSameAsOriginalErr();
		},
		selectedApplyStatus() {
			this.initSameAsOriginalErr();
		}
	},
	created() {},
	async mounted() {
        await this.checkSelectedKey();
		await this.checkQuickLogin();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		setBidHistoryPage() {
			sessionStorage.setItem('bidHistoryPage', `/Service/#/HappyPackage/${this.key}`);
		},
		checkQuickLogin() {
			if (!store.state.profile.name && !window.sessionStorage.bidReturnLoginUrl.endsWith(this.key)) {
				this.$router.push({ name: 'bid-login', query: { bidType: 'happyPackageGroup', returnUrl: `%2FService%2F%23%2FHappyPackage%2F${this.key}` } });
			} else {
				this.setBidHistoryPage();
			}
		},
        async checkSelectedKey() {

			if (!this.happyPackageGroups) {
				const getHappyPackageGroupListResp = await happyPackageApi.getHappyPackageGroupList();
				this.happyPackageGroups = getHappyPackageGroupListResp.happyPackageGroups;
				if (this.happyPackageGroups) {
					this.happyPackageGroups.forEach((hpg, hpgi) => {
						if (hpg.happyPackages) {
							hpg.happyPackages.forEach((hp, hpi) => {
								this.happyPackageMapping2Group[hp.key] = hpg.key;
							});
						}
					});
				}
			}
			
			if(!this.happyPackages) {
				const getHappyPackageListResp = await happyPackageApi.getHappyPackageList();
				this.happyPackages = getHappyPackageListResp.happyPackages;
			}

			if (this.happyPackageGroups && this.happyPackages) {
				this.selectedHappyPackage = this.getHappyPackage(this.selectedKey);
				this.selectedHappyPackageGroup = this.getHappyPackageGroup(this.happyPackageMapping2Group[this.selectedKey]);
				if (!this.selectedHappyPackage) {
					// not found
					this.$router.push({name: 'gt-error-404'});
				} else {
					await this.init();
				}
			}
		},
		async init() {
			if (store.state.profile.name) {
				// 一般登入
				this.getSetServiceStatusResp = await happyPackageApi.getSetServiceStatus(this.selectedHappyPackage.id);
			} else {
				// 快速登入
				this.getSetServiceStatusResp = await happyPackageApi.quickLogin.getSetServiceStatus(sessionStorage.getItem('bidMdn'), this.selectedHappyPackage.id);
			}
			if (this.getSetServiceStatusResp) {
				this.selectedApplyStatus = this.getSetServiceStatusResp.applyStatus;
				if (this.selectedHappyPackageGroup) {
					this.$store.state.breadCrumb = [breadCrumb.SERVICE, this.selectedHappyPackageGroup.title];
				} else {
					this.$store.state.breadCrumb = [breadCrumb.SERVICE];
				}
			}
		},
		async changeApplyStatus() {

			if (!this.customValid()) {
				return;
			}

			let changeSetServiceStatusResp = null;
			if (store.state.profile.name) {
				// 一般登入
				changeSetServiceStatusResp = await happyPackageApi.changeSetServiceStatus(this.selectedHappyPackage.id, this.selectedApplyStatus);
			} else {
				// 快速登入
				changeSetServiceStatusResp = await happyPackageApi.quickLogin.changeSetServiceStatus(sessionStorage.getItem('bidMdn'), this.selectedHappyPackage.id, this.selectedApplyStatus);
			}
			if (changeSetServiceStatusResp) {
				this.$router.push({name: 'gt-success', params: { title : this.selectedHappyPackage.title, returnUrl: process.env.PRE_PAGE_CODE }});
			}

		},
		customValid() {

			// init
			this.initSameAsOriginalErr();

			if (this.getSetServiceStatusResp.applyStatus == this.selectedApplyStatus) {
				this.sameAsOriginalErr = true;
				return false;
			} else {
				this.sameAsOriginalErr = false;
			}

			return true;
		},
		initSameAsOriginalErr() {
			this.sameAsOriginalErr = false;
		},
		getHappyPackageGroup(key) {
			for (let hpg of this.happyPackageGroups) {
				if (hpg.key == key) {
					return hpg;
				}
			}
			return null;
		},
		getHappyPackage(key) {
			for (let hp of this.happyPackages) {
				if (hp.key == key) {
					return hp
				}
			}
			return null;
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/happyPackage/happyPackage.js